import { render, staticRenderFns } from "./newsletter-form.vue?vue&type=template&id=42226c4e"
import script from "./newsletter-form.js?vue&type=script&lang=js&external"
export * from "./newsletter-form.js?vue&type=script&lang=js&external"
import style0 from "./newsletter-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports